import { ArrowUpRight, Inbox, Receipt, Smartphone, UserPlus, Users, CalendarClock } from "lucide-react";

const ACTIONS = [
  { id: "mobile-invoice", label: "Mobile invoice", icon: Smartphone, primary: true },
  { id: "new-client", label: "New client", icon: UserPlus },
  { id: "new-invoice", label: "New invoice", icon: Receipt },
  { id: "scheduling", label: "Scheduling", icon: CalendarClock },
  { id: "clients", label: "Clients", icon: Users },
  { id: "enquiries", label: "Enquiries", icon: Inbox },
];

export const AdminOverview = ({ onAction }) => (
  <section className="mt-8 border-t border-steel-border pt-6 sm:mt-10 sm:pt-8" data-testid="admin-overview">
    <h2 className="font-display text-base font-medium text-steel-text md:text-lg" data-testid="admin-overview-heading">Overview</h2>
    <p className="mt-2 font-mono text-xs uppercase text-steel-muted" data-testid="admin-quick-actions-heading">Quick actions</p>
    <div className="mt-5 grid min-w-0 grid-cols-2 gap-3 lg:grid-cols-3" data-testid="admin-quick-actions">
      {ACTIONS.map(({ id, label, icon: Icon, primary }) => (
        <button key={id} type="button" data-testid={`admin-quick-${id}`} onClick={() => onAction(id)}
          className={`group flex min-h-20 min-w-0 items-center gap-3 border px-4 py-4 text-left text-sm font-semibold transition-colors duration-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-steel-brass sm:px-6 ${primary
            ? "col-span-2 border-steel-brass bg-steel-brass/10 text-steel-brass hover:bg-steel-brass/20 lg:col-span-1 lg:row-span-2"
            : "border-steel-border bg-steel-surface text-steel-secondary hover:border-steel-brass hover:text-steel-text"}`}>
          <Icon aria-hidden="true" className={`${primary ? "h-6 w-6" : "h-5 w-5"} shrink-0`} />
          <span className="min-w-0 break-words">{label}</span>
          <ArrowUpRight aria-hidden="true" className="ml-auto hidden h-4 w-4 shrink-0 transition-transform duration-200 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 sm:block" />
        </button>
      ))}
    </div>
  </section>
);